import Badge from '@components/Badge';
import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { OrderResponse } from '@models/order/orderLog';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface Props {
    orderLog: OrderResponse;
}

function OrderInfo({ orderLog }:Props) {
    const { t } = useTranslation('orderLog');
    const {
        createdAt, shopName, shopOrderNo, displayOrderNo, orderType, status,
    } = orderLog;
    return <Container fullWidth as='section'
        align='center'
        spacing={4} >
        <Column align='center' spacing={1}>
            <Badge>
                {orderType === 'TAKE_OUT' ? t('info.pickup') : t('info.dineIn')}
            </Badge>
            <Text size='title' fontWeight='bold'>
                {shopName}
            </Text>
            <Text color='var(--color-text-secondary)' >
                {dayjs(createdAt).format('YYYY.MM.DD HH:mm')}
            </Text>
        </Column>
        <OrderNumberText size='display' fontWeight='bold' align='center'>
            {t('info.orderNumber', {
                number: (displayOrderNo || `${shopOrderNo}`).padStart(4, '0'),
            })}
            {status === 'CANCELLED' && (
                <>
                    &nbsp;
                    {t('info.cancelledLabel')}
                </>
            )}
        </OrderNumberText>
    </Container>;
}

const Container = styled(Column)`
    padding: var(--spacing-6) var(--spacing-4) var(--spacing-10);
`;

const OrderNumberText = styled(Text)`
    font-size: var(--font-size-24);
`;

export default OrderInfo;
